import { CustomIcon } from 'src/components'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import i18n from 'src/i18n'

const UnsupportedContent = () => (
  <div className="_d-flex _align-center _mb-2">
    <CustomIcon icon={faInfoCircle} className="_text-red" w="16px" h="16px" />
    <p className="_text-red _text-1 _font-weight _ml-1 _mb-0">
      {i18n.t('bottomsheet_post.unsupported_content')}
    </p>
  </div>
)

export default UnsupportedContent
